var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M66.84 57.91L116 8.72a5.18 5.18 0 0 0 .51-6.91 5 5 0 0 0-7.39-.35l-50.28 50.3h-.05L8.48 1.46a5 5 0 0 0-7.39.35 5.18 5.18 0 0 0 .51 6.91l49.19 49.19L1.6 107.1a5.18 5.18 0 0 0-.51 6.9 5 5 0 0 0 7.39.35l50.31-50.3h.05l50.31 50.3a5 5 0 0 0 7.39-.35 5.18 5.18 0 0 0-.51-6.91z"}));
}

Close.defaultProps = {"viewBox":"0 0 117.63 115.82"};

module.exports = Close;

Close.default = Close;
